import { ORDERS_STATUS } from 'config/environments/shared';

import Styles from '../Tracking.styles';
import { StatusItem } from './StatusItem';

type TrackingStepsProps = {
  tagStatus: string;
};

export const TrackingSteps = ({ tagStatus }: TrackingStepsProps) => {
  if (tagStatus === ORDERS_STATUS.CANCELED) {
    return (
      <Styles.StatusWrapper>
        <StatusItem status='capture' />
        <StatusItem status='canceled' />
      </Styles.StatusWrapper>
    );
  }

  return (
    <Styles.StatusWrapper>
      <StatusItem status='capture' />
      <StatusItem status='paymentProcess' />
      <StatusItem status='processing' />
      <StatusItem status='picking' />
      <StatusItem status='delivering' />
      <StatusItem status='delivered' />
    </Styles.StatusWrapper>
  );
};
